import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key (with error handling)
let stripePromise = null;

const getStripePromise = () => {
  if (!stripePromise && process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY).catch((error) => {
      console.warn('Stripe failed to load:', error.message);
      return null;
    });
  }
  return stripePromise;
};

// Lazy load Stripe only when needed
const stripeInstance = getStripePromise();

/**
 * Create a Stripe Checkout session for subscription
 * @param {string} priceId - Stripe Price ID (unused, kept for compatibility)
 * @param {string} customerEmail - Customer's email address
 * @param {object} signupData - Signup form data to pass to Stripe
 */
export const createCheckoutSession = async (priceId, customerEmail, signupData = {}) => {
  try {
    console.log('=== CREATING CHECKOUT SESSION ===');
    console.log('Price ID:', priceId);
    console.log('Customer Email:', customerEmail);
    console.log('Signup Data:', signupData);
    
    // Call Netlify function to create checkout session
    const response = await fetch('/.netlify/functions/create-checkout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        priceId: priceId,
        email: customerEmail,
        firstName: signupData.firstName,
        lastName: signupData.lastName,
        allergies: signupData.allergies,
        healthGoals: signupData.healthGoals,
        fitnessLevel: signupData.fitnessLevel,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create checkout session');
    }

    const { url } = await response.json();
    console.log('Redirecting to Stripe Checkout:', url);
    
    // Redirect to Stripe Checkout
    window.location.href = url;
    
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

/**
 * Get the monthly subscription price ID from environment
 */
export const getMonthlyPriceId = () => {
  return process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID;
};

/**
 * Get the annual subscription price ID from environment
 */
export const getAnnualPriceId = () => {
  return process.env.REACT_APP_STRIPE_ANNUAL_PRICE_ID;
};

/**
 * Check if Stripe is properly configured
 */
export const isStripeConfigured = () => {
  return !!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
};

export default stripeInstance;
